import graphql__39f950e8250ed5dcc017 from "./__generated__/CreateEmailLayoutDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Field from "../form/Field";
import Row from "../form/Row";
import Label from "../form/Label";
import * as yup from "yup";
import FormDialog from "../dialog/FormDialog";
import type {CreateEmailLayoutDialogMutation} from "./__generated__/CreateEmailLayoutDialogMutation.graphql";
import {useNavigate} from "react-router-dom";
import {useRelayEnvironment} from "react-relay/hooks";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import {useIntl} from "react-intl";

type Props = {
    onClose: () => void
}

const CreateEmailLayoutDialog: React.FC<Props> = ({onClose}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const navigate = useNavigate();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling<CreateEmailLayoutDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__39f950e8250ed5dcc017,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    onClose();
                    navigate('/marketing/layouts/' + response.createEmailLayout?.id)
                },
                onError: (error) => {
                    console.error(error);
                    onClose();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToCreateEmailLayout'})
            }
        )
    }

    const initialValues = {
        name: '',
    }

    const validationSchema = yup.object().shape({
        name: yup.string()
            .min(2, intl.formatMessage({id: 'validation.field.nameTooShort'}))
            .max(255, intl.formatMessage({id: 'validation.field.nameTooLong'}))
            .required(intl.formatMessage({id: 'validation.field.required'})),
    });

    return (
        <FormDialog handleCloseDialog={onClose}
                    handleSubmission={handleSubmission}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    headline={intl.formatMessage({id: 'dialog.CreateEmailLayoutDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'button.create'})}>
            <Section>
                <Row>
                    <Label>{intl.formatMessage({id: 'dialog.CreateEmailLayoutDialog.nameLabel'})}</Label>
                    <Field name="name" type="text" autoFocus={true} placeholder={intl.formatMessage({id: 'dialog.CreateEmailLayoutDialog.namePlaceholder'})} data-1p-ignore="true"/>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default CreateEmailLayoutDialog;
